"use client";

import { LogOut, ShieldAlert } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./dialog";
import { Button } from "./button";

/**
 * Blocking session-expired dialog.
 * Cannot be dismissed via Esc, overlay click, or X — only via Log out.
 */
export default function SessionExpiredModal({
  isOpen,
  onLogout,
  isLoggingOut = false,
}) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(nextOpen) => {
        // Controlled + ignore close attempts; only Log out clears it in AuthContext
        if (!nextOpen) return;
      }}
    >
      <DialogContent
        showCloseButton={false}
        className="sm:max-w-md"
        onInteractOutside={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader className="text-center sm:text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
            <ShieldAlert className="h-8 w-8 text-amber-600" />
          </div>
          <DialogTitle className="text-xl font-bold text-gray-900">
            Session expired
          </DialogTitle>
          <DialogDescription className="text-gray-600">
            Your session has expired for security. Live updates are paused.
            Log out to sign in again with a clean session.
          </DialogDescription>
        </DialogHeader>

        <div className="pt-2">
          <Button
            onClick={onLogout}
            disabled={isLoggingOut}
            className="w-full bg-teal-600 hover:bg-teal-700 text-white font-semibold"
          >
            {isLoggingOut ? (
              <span className="flex items-center justify-center gap-2">
                <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                Logging out…
              </span>
            ) : (
              <span className="flex items-center justify-center gap-2">
                <LogOut className="h-4 w-4" />
                Log out
              </span>
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
